module.exports = __webpack_public_path__ + "ebb3e61e5df5edaee2a217ac58c346c1.svg";